module.exports = {
  schema: {
    name: '客戶資料',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '客戶編碼',
        unique: true,
      },
      fax: {
        type: 'String',
        name: '傳真',
      },
      phone: {
        type: 'String',
        name: '電話',
      },
      email: {
        type: 'String',
        name: 'email',
      },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'phone', width: 130 },
        { key: 'fax', width: 130 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '基本客戶資料',
          rows: [
            [{ key: 'key' }, { key: 'email' }],
            [{ key: 'fax' }, { key: 'phone' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/customers.js